export const isNil = <T>(
  item: T | null | undefined,
): item is null | undefined => item == null;
